import { AgentWeather } from "./Interfaces/AgentTypes";
import { JsonBuilderServiceModel } from "./Interfaces/jsonInterface";
import { defaultSensepass, defaultStripeCheckout } from "./Interfaces/PaymentMethods";

const defaultAgentWeather: AgentWeather = {
    componentText: 'Search',
    componentColor: '#4f46e5',
    themeColor: '#111827',
    location: "Enter Location",
    locationColor: "#4f46e5",
    locationComponentColor: "#111827",
    airQuality: "<span style='font-weight: 700;font-size: 2.25rem;line-height: 2.5rem;text-align: center;margin: 0;'>Air Quality</span>",
    airQualityToggle: false,
    celsiusToggle: true,
    outputToggle: false,
    feelsLike: "Feels Like",
    wind: "Wind",
    humidity: "Humidity",
    cloudCover: "Cloud Cover",
    uvIndex: "UV Index",
    pressure: "Pressure",
    airQualityCO: "CO",
    airQualityNO2: "NO2",
    airQualityO3: "O3",
    airQualitySO2: "SO2",
    airQualityPM25: "PM2.5",
    airQualityPM10: "PM10",
  };

export const initialAppState: JsonBuilderServiceModel = {
    _id: "",
    customPrompt:"",
    description: '',
    localeCode:'en',
    translatedFields:{},
    parentApp:"",
    icon: '',
    agent:defaultAgentWeather,
    name: "",
    appUUID: "",
    url: "",
    header: {
      logo: {
        enabled: false,
        alignment: "left",
        size: "",
        url: "https://dlvkyia8i4zmz.cloudfront.net/X2lN5NGWQEeRUUjujnvj_logo.svg",
        altText: "logo",
        link: "https://autoolic.com",
      },
    },
    footer: false,
    visuals : {
      graph: null,
      table: null,
      visible: false,
      type: 'image',
      videoLink: 'https://www.youtube.com/embed/PmN_MY5kNrE',
      imageLink: 'https://dlvkyia8i4zmz.cloudfront.net/QJ2FtTAmRHuDVxWR4aDP_img.png',
      imageSize: 1572000,
      imageFit: 'cover',
      imageName: 'default.jpg',
      imageAlt: '',
      videoType: 'youTube',
    },
    changed: false,
    componentCode: "",
    apis: [
      {
        api: "",
        key: ""
      },
    ],
    status: "dev",
    agent_type: "",
    theme: {
      enabled: false,
      primaryColor: "#FF6468",
      backgroundColor: "#F5F5F5",
      secondaryColor: "#646C6C",
    },
    domain: {
      type: "",
      default: "",
      trim: true,
    },
    useBrandDetail: true,
    brandDetail: {
      fonts: [],
      colors: [],
      logo: "",
      favicon: "",
      title: "",
      description: "",
      topImages: [],
    },
    leadForm: {
      title:'<strong>How can we get in touch?</strong>',
      hideDuplicates:false,
      fb_lead:false,
      showSubTitle:true,
      enabled: false,
      subTitle:'Receive new articles and resources directly on your inbox. Fill your email below to join our email newsletter today.',
      skip: false,
      fields: [
        {
          type: 'fullName',
          key:'fullname',
          fileName: [],
          fieldsArray: [{ text: "" }],
          givenArray: [],
          previousIcons: [],
          name: "First Name",
          unique: false,
          placeholder: "First Name",
          value: "",
          subType: "",
          emailValidator: false,
          freeEmailValidator: false,
          disposableEmailValidator: false,
          lowDeliverEmailValidator: false,
          validations: {
            required: {
              status: true,
              message: "Field is Required",
            },
            minLength: {
              status: false,
            },
            maxLength: {
              status: false,
            },
          },
          icon: "",
          errorInUploading: false,
          uploadErr:'',
          inProgress: false,
          steps: 0,
          uniquedpValue: '',
        },
        {
          type: "email",
          key:'email',
          fileName: [],
          fieldsArray: [
              {
                  text: ""
              }
          ],
          givenArray: [],
          previousIcons: [],
          name: "Email",
          unique: false,
          placeholder: "Email",
          value: "",
          subType: "",
          emailValidator: false,
          freeEmailValidator: false,
          disposableEmailValidator: false,
          lowDeliverEmailValidator: false,
          validations: {
              required: {
                  status: true,
                  message: "Field is Required"
              },
              minLength: {
                  status: false
              },
              maxLength: {
                  status: false
              }
          },
          icon: "",
          errorInUploading: false,
          uploadErr:'',
          inProgress: false,   
          steps: 0,
          uniquedpValue: '',
        }
      ],
      thankYouMessage: "Thank you for your interest! We'll be in touch soon.",
      enableRedirect: false,
      redirectUrl: "/thank-you",
      buttonText:'Submit',
      isIconPresent:true,
      loginMode:false,
      isSignupMode:false
    },
    payments:{
      enabled:false,
      paymentType: 'stripeCheckout',
      providers:  [defaultStripeCheckout,defaultSensepass],
    },
    paymentSetting: {
      enabled:false,
      paymentType: 'stripeCheckout',
      chargebeeScript: '',
      chargebeeCta: [
        {
          redirect: {
            type: 'url',
            urlRedirectType: 'url',
            urlLink: 'https://autoolic.com',
            open_in_tab: true
          },
          buttonCode: '',
          ctaLabel: 'Button Text'
        },
      ]
    },
    isLive: false,
    visitorKey: '',
    tool_type: '',
    ai: {
      model:'',
      key:''
    },
    serpAPI: {
      status: false,
      credentials: {
        key: ''
      }
    },
    googlePlacesAPI: {
      status: false,
      credentials: {
        key: ''
      }
    },
    googleCalendar: {
      status: false,
      credentials: {
        clientEmail: '',
        privateKey: '',
        calendarId: ''
      }
    },
    featuresAvailable:[],
    features:[],
    showLoginPopup:false,
    globalPopup: {
      isOpen: false,
      title: '',
      message: '',
      primaryButtonText: 'Stay here',
      secondaryButtonText: '',
      showSecondaryButton: false,
      secondaryButtonUrl: '',
      primaryButtonUrl: '',
      className: '',
      iconClassName: '',
      titleClassName: '',
      messageClassName: '',
      buttonClassName: '',
      icon: ''
    } ,
    enhancelimitCount:0,
    uploadimagelimitCount:0,
    selectedTab: 'Premades',
    reCaptcha: {
      type: false,
      version: 'v2',
      siteKey: '',
      secretKey: ''
    },
    rateLimiter:{
      enabled:false,
      value:30
    },
    enabledSingleAttempt: {
      enabled: false,
      restrictEmailEnabled: false,
      restrictIPEnabled: false,
    },
    mode: "PUBLIC",
  };